import { Anchor, Breadcrumbs, Grid, Group, Text } from '@mantine/core';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import PushNotificationForm from '../../components/PushNotifications/PushNotificationForm';
import Spinner from '../../components/Spinner';
import GuidanceModal from '../../components/UserFlows/guidanceModal';
import { Page } from '../../constants/pageTitles';
import useFetch from '../../helpers/useFetch';

const page = `${Page['pushNotifications']}`;

const PushNotificationsDetailsPage = () => {
  const navigate = useNavigate();
  const fetch = useFetch();
  const location = useLocation();
  const [guidanceShow, setGuidanceShow] = useState(false);
  const [useInAutomation, setUseInAutomation] = useState(false);

  const [pushNotification, setPushNotification] = useState();
  const [userError, setUserError] = useState();
  const [loadError, setLoadError] = useState();
  const [deleteError, setDeleteError] = useState();
  const { accountId, domainId, pushNotificationId } = useParams();

  useEffect(() => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/pushNotifications/${pushNotificationId}`)
      .then(({ pushNotification }) => {
        if (!pushNotification) {
          navigate(`/accounts/${accountId}/domains/${domainId}/push`);
        }

        setPushNotification(pushNotification);
      })
      .catch(setLoadError);
  }, [fetch, navigate, accountId, domainId, pushNotificationId]);

  const update = (pushNotification) => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/pushNotifications/${pushNotificationId}`, {
      method: 'PUT',
      body: JSON.stringify(pushNotification),
    })
      .then((redirect) => {
        setGuidanceShow(false);
        redirect && navigate(`/accounts/${accountId}/domains/${domainId}/push`);
      })
      .catch(setUserError);
  };

  const del = (cb) => {
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/pushNotifications/${pushNotification.id}`, {
      method: 'DELETE',
    })
      .then(() => {
        if (typeof cb === 'function') {
          cb();
        }
        navigate(location.pathname.replace(`/push/${pushNotification.id}/details`, '/push'));
      })
      .catch(setDeleteError);
  };

  const showUserFlow = () => {
    setGuidanceShow(true);
    setUseInAutomation(true);
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (!pushNotification) {
    return <Spinner />;
  }

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/push` },
    { title: pushNotification.name, href: `#${location.pathname.replace('/details', '/analytics')}` },
    { title: 'Edit' },
  ].map((item, index) =>
    item.href ? (
      <Anchor href={item.href} key={index}>
        {item.title}
      </Anchor>
    ) : (
      <Text key={index}>{item.title}</Text>
    )
  );

  return (
    <>
      <Metadata title={`${page} | ${pushNotification.name} | Edit`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>
      <GuidanceModal
        type="Push Notification"
        redirect={`/accounts/${accountId}/domains/${domainId}/push`}
        show={guidanceShow}
        elementTypes={['workflows']}
        element={pushNotification}
        setShow={() => {
          setGuidanceShow(false);
          setUseInAutomation(false);
        }}
        useInAutomation={useInAutomation}
      />
      <Grid>
        <Grid.Col span={12}>
          <PushNotificationForm
            pushNotification={pushNotification}
            savePushNotification={(pushNotification) => {
              update(pushNotification);
            }}
            deletePushNotification={(cb) => del(cb)}
            showUserFlow={() => {
              showUserFlow(false);
            }}
            deleteError={deleteError?.message}
            onBack={() => navigate(-1)}
          />
        </Grid.Col>
      </Grid>
      {userError ? (
        <Group justify="flex-end">
          <ErrorMessage message={userError.message} />
        </Group>
      ) : null}
    </>
  );
};

export default PushNotificationsDetailsPage;
